module.exports = "<input [(ngModel)]=\"key\" name=\"key\">\n<button (click)=\"onClick()\">Click Me</button>"